import { render, staticRenderFns } from "./WfConsumerCorpGroupModal.vue?vue&type=template&id=67981fb6&"
import script from "./WfConsumerCorpGroupModal.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports